import { Component, Input } from '@angular/core'

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'

@Component({
    selector: 'sf-boolean-icon',
    imports: [FontAwesomeModule],
    templateUrl: './boolean-icon.component.html',
    styleUrls: ['./boolean-icon.component.scss']
})
export class BooleanIconComponent {
    @Input()
    value: boolean = false
}
